import React from 'react';

const VideoLoader = () => {
  return (
    <div className="video-loader">
      <div className='Spinner-effect'>
        <div className='Spin'>
          <img className="Spinner-NLF" src="/Navlogo/NLFLogo.gif" />
          <img className="Spinner-logo" src='NLF1.jpeg' alt='NLF' />
        </div>
      </div>
    </div>
  );
}

export default VideoLoader;